import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";

function PagarmultaWrapper(props) {
    const params = useParams();
    return <Pagarmulta {...props} params={params} />;
}

class Pagarmulta extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datosCargados: false,
            idmulta: "",
            nombrec: "",
            dpi: "",
            nit: "",
            fecha: "",
            monto: "",
            serie:"",
            recibo: "",
            nochapa: "",
            observaciones:"",
            mensaje: "",
            redireccionar: false
        };
    }

    cambioValor = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

  componentDidMount() {
    const idmulta = this.props.params.id;

    fetch(api + "multas/" + idmulta, {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {

        

        const multa = datosRespuesta.multa;

        if (!multa || !multa.idmulta) {
            this.setState({
                datosCargados: true,
                mensaje: "No se encontró la multa"
            });
            return;
        }

        this.setState({
            datosCargados: true,
            idmulta: multa.idmulta,
            nombrec: multa.nombrec || "",
            dpi: multa.dpi || "",
            nit: multa.nit || "",
            fecha: multa.fecha,
            monto: multa.monto,
            nochapa: multa.nochapa || ""
        });
    })
    .catch(error => {
        
        this.setState({
            datosCargados: true,
            mensaje: "Error al cargar multa"
        });
    });
}

    enviarPago = (e) => {
    e.preventDefault();

    const usuario = JSON.parse(localStorage.getItem("usuario"));

    const datosEnviar = {
        monto: this.state.monto,
        serie: this.state.serie,
        recibo: this.state.recibo,
        observaciones: this.state.observaciones,
        idusuario: usuario.idusuario
    };

    fetch(api + "multas/" + this.state.idmulta + "/pagar", {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify(datosEnviar)
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {

     

        if (datosRespuesta.success === 1) {
            this.setState({
                mensaje: "Pago registrado con éxito"
            });

            setTimeout(() => {
                this.setState({
                    redireccionar: true
                });
            }, 2000);
        } else {
            this.setState({
                mensaje: datosRespuesta.mensaje || "No se pudo registrar el pago"
            });
        }
    })
    .catch(error => {
       
        this.setState({
            mensaje: "Error al conectar con el servidor"
        });
    });
}

    render() {
        const {
            datosCargados,
            idmulta,
            nombrec,
            dpi,
            nit,
            fecha,
            monto,
            serie,
            recibo,
            nochapa,
            observaciones,
            mensaje,
            redireccionar
        } = this.state;

        if (redireccionar) {
            return <Navigate to="/listarmultas" />;
        }

        return (
            <div className="card shadow-sm">
                <div className="card-header bg-success text-white">
                    <h5 className="mb-0">Registrar pago de multa</h5>
                </div>

                <div className="card-body">
                    {mensaje && (
                        <div className="alert alert-success" role="alert">
                            {mensaje}
                        </div>
                    )}

                    {datosCargados ? (
                        <form onSubmit={this.enviarPago}>

                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <label>ID Multa</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={idmulta}
                                        readOnly
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label>Fecha</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={fecha}
                                        readOnly
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label>Monto</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={monto}
                                        readOnly
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label>Conductor</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={nombrec}
                                        readOnly
                                    />
                                </div>

                                <div className="col-md-2 mb-3">
                                    <label>DPI</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={dpi}
                                        readOnly
                                    />
                                </div>

                                <div className="col-md-2 mb-3">
                                    <label>NIT</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={nit}
                                        readOnly
                                    />
                                </div>
                            </div>

                            <div className="col-md-2 mb-3">
                                <label>Chapa Agente</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={nochapa}
                                    readOnly
                                />
                            </div>

                            <hr />

                            <div className="row">
    
    <div className="col-md-2 mb-3">
        <label htmlFor="serie">Serie</label>
        <input
            type="text"
            name="serie"
            id="serie"
            className="form-control"
            value={serie}
            onChange={this.cambioValor}
            placeholder="Ejemplo: A"
            required
        />
    </div>

    <div className="col-md-3 mb-3">
        <label htmlFor="recibo">Número de recibo</label>
        <input
            type="text"
            name="recibo"
            id="recibo"
            className="form-control"
            value={recibo}
            onChange={this.cambioValor}
            placeholder="Ingrese número de recibo"
            required
        />
    </div>

    <div className="mb-3">
    <label htmlFor="observaciones">Observaciones</label>
    <textarea
        name="observaciones"
        id="observaciones"
        className="form-control"
        value={observaciones}
        onChange={this.cambioValor}
        placeholder="Ingrese observaciones del pago si aplica"
        rows="3"
    />
</div>

</div>

                            <div className="btn-group" role="group">
                                <button type="submit" className="btn btn-success">
                                    Registrar pago
                                </button>

                                <Link to="/listarmultas" className="btn btn-secondary">
                                    Cancelar
                                </Link>
                            </div>
                        </form>
                    ) : (
                        <p>Cargando datos de la multa...</p>
                    )}
                </div>

                <div className="card-footer text-muted">
                    PMT
                </div>
            </div>
        );
    }
}

export default PagarmultaWrapper;